import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import centeredStyle from "../styles/centeredStyle";

function InternalLinkingFull({ img, href, text }) {
  console.log(img);
  return (
    <Link href={href} underline="none">
      <Box
        sx={{
          height: {
            xs: "20vh",
            md: "25vh",
            lg: "40vh",
            xl: "25vh",
            position: "relative",
          },
        }}
      >
        <div className="fade-in-overlay" />
        <div className={`redesign`} style={{ backgroundImage: `url(${img})` }}>
          <div className="overlay service-overlay" />
          <Box
            sx={{
              ...centeredStyle,
              color: "white",
            }}
          >
            <Typography variant="h3" sx={{ fontWeight: 700 }}>
              {text}
            </Typography>
          </Box>
        </div>
      </Box>
    </Link>
  );
}

export default InternalLinkingFull;
